export default "__VITE_ASSET__DAeZ0uCQ__"